import $ from 'jquery';

/**
 * Performs a REST Call
 * 
 * @return null
 */

export function restCall( parameters ){
    // Define the valid endpoints
    let validEndpoints = [ 'change_user_progress' ];

    // Check if the endPoint parameter is a valid endpoint
    if ( validEndpoints.includes( parameters.endpoint ) ){
        // Do AJAX
        $.ajax({
            method: 'POST',
            url:    parameters.url + parameters.endpoint + '/',
            data:   $.param( parameters.data ) + '&' + $.param({ doing_rest: 1 }),

            // Attach Nonce the the header of the request
            beforeSend: function( xhr ){
                xhr.setRequestHeader( 'X-WP-Nonce', parameters.nonce );
            },

            success: function( response ){

                // Check if onDone is defined
                if ( isDefined( parameters.onDone ) ){
                    // Invoke callback
                    parameters.onDone( response );
                }

                // Check if onSuccess is defined
                if ( isDefined( parameters.onSuccess ) ){
                    // Invoke callback
                    parameters.onSuccess( response );
                }
            },

            statusCode: {
                403: function(){
                    location.reload();
                }
            },

            fail: function ( response ){
                // Check if onDone is defined
                if ( isDefined( parameters.onDone ) ){
                    // Invoke callback
                    parameters.onDone( response );
                }
                
                if ( isDefined( parameters.onFail ) ){
                    parameters.onFail( response );
                }
            },
        });
    }
    else {
        console.error( `The ${ parameters.endpoint } endPoint does not exists` );
    }
}

/**
 * Determine if a variable is set and is not NULL
 *
 * @param  {mixed}      variable - The variable being evaluated
 * @return {boolean}    TRUE if the variable is defined
 */

export const isDefined = ( variable ) => {
	// Returns true if the variable is undefined
    return typeof variable !== 'undefined' && variable !== null;
}

/**
 * Determine whether a variable is empty
 *
 * @param   {mixed}     variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is empty
 */

export const isEmpty = ( variable ) => {
    let response = true;

    // Check if the variable is defined, otherwise is empty
    if ( isDefined( variable ) ){
        // Check if it's array
        if ( variable.isArray ){
            response = variable.length == 0;
        }
        else if ( isObject( variable ) ){
            response = Object.keys( variable ).length;
        }
        else {
            response = variable == '';
        }
    }

    return response;
}

/**
 * Determine whether a variable is an object
 *
 * @param   {mixed}     variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is an object
 */

export const isObject = ( variable ) => {
    return typeof variable === 'object' && variable !== null;
}

/**
 * Format number
 * @param  {float}  amount        The number
 * @param  {int}    decimalCount  Number of decimals
 * @param  {string} decimal       The decimal separator
 * @param  {string} thousands     The thousands separator
 * @return {string}               Formatted number
 */

export const formatNumber = ( amount, decimalCount = 2, decimal = '.', thousands = ',' ) => {
    decimalCount = Math.abs( decimalCount );
    decimalCount = isNaN( decimalCount ) ? 2 : decimalCount;

    let i = parseInt( amount = Math.abs( Number( amount ) || 0 ).toFixed( decimalCount ) ).toString();
    let j = ( i.length > 3 ) ? i.length % 3 : 0;

    return ( j ? i.substr( 0, j ) + thousands : '' ) + i.substr( j ).replace( /(\d{3})(?=\d)/g, '$1' + thousands ) + ( decimalCount ? decimal + Math.abs( amount - i ).toFixed( decimalCount ).slice( 2 ) : '' );
};

/**
 * Destroy iCheck
 */

export const destroyiCheck = () => {
    // Check iCheck
    if ( typeof jQuery.fn.iCheck !== 'undefined' ){
        // Destroy iCheck checkboxes
        jQuery( '.uo-checkbox input' ).iCheck( 'destroy' );
        jQuery( '.uo-checkbox input' ).on( 'ifCreated', function( event ){
            // Destroy iCheck
            setTimeout(function(){
                jQuery( event.currentTarget ).iCheck( 'destroy' );
            }, 100 );
        });
    }  
}

/**
 * Debounces a function
 *
 * @param {Function} func     The function to debounce
 * @param {Integer}  interval The interval, in milliseconds
 * @return {Function}         The function debounced
 */
export const debounce = ( func, interval ) => {
	let lastCall = -1;

	return () => {
		clearTimeout( lastCall );
		// eslint-disable-next-line no-undef
		const args = arguments;
		const self = this;
		lastCall = setTimeout( () => {
			func.apply( self, args );
		}, interval );
	};
};
